export const STATUS_LABELS = {
  connecting: 'Connecting',
  connected: 'Connected',
  reconnecting: 'Reconnecting',
  disconnected: 'Disconnected',
};

export const REGISTER_BINDING_STATUS_LABELS = ['Active', 'Retired'];
export const REQUEST_STATUS_LABELS = ['Created', 'InProgress', 'AwaitingConfirmation', 'Completed', 'Cancelled'];
export const CONFIRMATION_STATUS_LABELS = ['Pending', 'Confirmed', 'Rejected'];
export const READING_STATUS_LABELS = ['Pending', 'Accepted', 'Rejected', 'Superseded'];
export const DEVICE_STATUS_LABELS = ['Active', 'Inactive', 'Issue', 'Maintenance'];

export const KIOSK_SELECTED_REGISTER_STORAGE_KEY = 'kiosk:selected-register';
export const KIOSK_OPERATOR_NAME_STORAGE_KEY = 'kiosk:operator-name';

export const EMPTY_REQUEST_FORM = {
  requestLoadId: '',
};

export const OPEN_LOAD_STATUSES = new Set(['Open', 'InProgress']);
